module.exports = __webpack_public_path__ + "img/kt-bg.d3254c75.png";